import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer style={styles.footer}>
      <p>
        <Link to="/legal" style={styles.link}>
          Legal Notice
        </Link>{' '}
        • Contact: <a href="mailto:support@cheerclip.com" style={styles.link}>support@cheerclip.com</a>
      </p>
    </footer>
  );
};

const styles = {
  footer: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
    textAlign: 'center',
    padding: '1rem 0',
    backgroundColor: '#f0fdfa',
    fontSize: '0.9rem',
    color: '#234e52',
    borderTop: '1px solid #c6f6d5',
  },
  link: {
    color: '#2c7a7b',
    textDecoration: 'underline',
  },
};

export default Footer;
